/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBookedShiftsOutput } from "../../entities/models/BookedShiftsOutput";
import { modelsBookedShiftOutputSchema } from "./bookedShiftOutputSchema";
import { z } from "zod/v4";

export const modelsBookedShiftsOutputSchema = z.object({
    "from": z.optional(z.string()),
get "shifts"(){
                return z.array(modelsBookedShiftOutputSchema).optional()
              },
"to": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBookedShiftsOutput>